import { FormEvent, MouseEvent, useState } from 'react'
import {
  Box,
  Button,
  Checkbox,
  Divider,
  FormControlLabel,
  Stack,
  Typography,
} from '@mui/material'
import Input from '../../Common/Input/Input'
import PasswordInput from '../../Common/PasswordInput/PasswordInput'
import Link from 'next/link'
import LoginWithSocial from '../LoginWithSocial'
import { signIn } from 'next-auth/react'
import toast from 'react-hot-toast'
import { useRouter } from 'next/router'
import Logo from '../../Common/Logo/Logo'

const RegisterWrapper: React.FC = () => {
  const router = useRouter()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [selectedRole, setSelectedRole] = useState<'talent' | 'recruiter'>(
    'talent'
  )
  const [isAccepted, setIsAccepted] = useState(false)
  const credentialsLoginHandler = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()

    const regex = new RegExp(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%.,_-~;=*?&])[A-Za-z\d@$!%.,_-~;=*?&]{8,}$/
    )

    if (!regex.test(password)) {
      toast.error(
        'Password must contain at least one uppercase letter, one lowercase letter and one number'
      )
      return
    }

    if (!isAccepted) {
      toast.error('Please accept the terms of conditions')
      return
    }

    try {
      const res = await signIn('credentials', {
        redirect: false,
        email,
        password,
        is_register: true,
      })

      if (res?.status === 200) router.push('/r')
      else toast.error(' credentials')
    } catch (error) {}
  }

  return (
    <Stack
      width={1}
      component={'form'}
      className="default-form"
      onSubmit={credentialsLoginHandler}
    >
      <Box mb={5}>
        <Link href={'https://jobin.ai'}>
          <Logo />
        </Link>
      </Box>
      <Typography variant="h5_xl" mb={3.75}>
        Create a Jobin.ai Account
      </Typography>

      <Stack spacing={3.75}>
        <Input
          type="email"
          id="email"
          label="Email"
          placeholder="johndoe@gmail.com"
          value={email}
          onChange={e => setEmail(e.target.value)}
        />
        <PasswordInput
          label="Password"
          placeholder="Password"
          id="password-modal"
          value={password}
          onChange={e => setPassword(e.target.value)}
          required
        />
      </Stack>

      <Box mt={2.5}>
        <FormControlLabel
          control={<Checkbox />}
          checked={isAccepted}
          onChange={(event, checked) => setIsAccepted(checked)}
          label={
            <Stack direction={'row'} spacing={0.5}>
              <Typography variant="body_s_regular">
                Yes, I understand and agree to the{' '}
              </Typography>
              <Link href={'/terms-and-conditions'}>
                <Typography
                  variant="body_s_medium"
                  sx={{
                    textDecoration: 'underline',
                  }}
                >
                  Jobin Terms of Conditions.
                </Typography>
              </Link>
            </Stack>
          }
          labelPlacement="end"
        />
      </Box>
      <Stack spacing={2.5} mt={3.75}>
        <Button type="submit">Sign Up</Button>
        <Stack direction={'row'} spacing={1} justifyContent={'center'}>
          <Typography variant="body_s_regular" color={'darkGray.main'}>
            Do you have an account?
          </Typography>
          <Link href={'/auth'}>
            <Typography variant="body_s_medium" color={'mediumGreen.main'}>
              Login
            </Typography>
          </Link>
        </Stack>
        <Divider>
          <Typography variant="body_s_regular" color={'mediumGray.main'}>
            or
          </Typography>
        </Divider>
        <LoginWithSocial />
      </Stack>
    </Stack>
  )
}

export default RegisterWrapper
